import React, {
	useContext,
	useState,
	useRef,
	useCallback,
	useEffect,
} from 'react';
import columns from './columns';
import { Table, Icon } from 'components';
import { useAuth } from 'contexts/AuthContext';
import { ListContext } from 'contexts/ListContext';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { t } from 'i18next';
import LongTextCell from './../PatientsTable/LongTextCell';

export const PatientsTable = () => {
	const { user } = useAuth();
	const fetchIdRef = useRef(0);
	const {
		list,
		listData,
		setListData,
		setFilterText,
		fetching,
		fetchList,
		setOrderBy,
	} = useContext<any>(ListContext);
	const [loading, setLoading] = useState(false);

	const fetchData = useCallback(
		async ({ pageSize, pageIndex, filterText, orderBy }) => {
			try {
				let lastPage = localStorage.getItem('lastPagePatients');
				if (lastPage) {
					console.log('last page', lastPage);
					setListData({ ...listData, currentPage: lastPage, size: pageSize });
				} else {
					setListData({ ...listData, currentPage: pageIndex, size: pageSize });
				}
				setFilterText(filterText);
				setLoading(true);
				const fetchId = ++fetchIdRef.current;
				if (fetchId === fetchIdRef.current) {
					const res = await fetchList();
				}
			} catch (error) {
				Swal.fire({
					title: 'Error',
					text: 'Hubo un problema intentando obtener los usuarios, vuelva a intentar',
				});
				console.log({ error });
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	let cols = [
		...columns,
		{
			Header: '',
			accessor: 'id',
			Cell: ({ value }: { value: string }) => {
				return (
					<Link to={`/patient/${value}`}>
						<Icon
							name='ClinicalHistory'
							className='relative block mx-auto'
						/>
					</Link>
				);
			},
		},
	];

	if (user.isAdmin) {
		cols = [
			{
				Header: 'Code OP',
				accessor: 'codeOP',
				canSort: true,
				Cell: ({ value }: any) => {
					return value != null ? `AL-OP# ${value}` : '';
				},
			},
			...cols,
		];

		let ngsOp = {
			Header: 'NGS OP',
			canSort: false,
			accessor: 'ngsOp',
			Cell: ({ value }: any) => {
				return <LongTextCell value={value} />
			},
		}

		cols.splice(cols.length -2, 0, ngsOp);
	}

	return (
		<Table
			cols={cols}
			fetchData={fetchData}
			loading={loading || fetching}
			pageCount={listData?.totalPages}
			noDataMsg={t('noPatients')}
			totalItems={listData?.totalItems}
			data={list}
		/>
	);
};
